module.exports = __webpack_public_path__ + "assets/img/w-b-1.b77db0da.png";